// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,  
  name:'dev',
  //apiUrl: 'https://wa-r2c-ui-dev-ang.azurewebsites.net/',
  //cccUrl: 'https://wa-r2c-ui-dev-ang.azurewebsites.net/',
  apiUrl:'http://localhost:1358/',
  cccUrl: 'http://localhost:4200/',
  //wa-r2c-ui-dev-ang.azurewebsites.net,
  siteUrl:'https://wa-r2c-ui-dev-ang.azurewebsites.net/',
  "idleSid": "WA7942ac64425fe6d66cd07e3eec122a64",
  "busySid": "WAaf374be766ef12e9e76a0235a0eaa278",
  "deleteSid": "WA19d265807b3d5688c6a1fe9f77656e8f",
  "offlineSid": "WA4c7e36d428df09629362ea889273bee9",
  "reservSid": "WA9c2c3a6c63eef5274d0d31e3d423670b",    
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
  // import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
